<template>
  <div class="d-flex align-items-center" :class="{'dark':skinType}">
    <i v-if="title==='el-icon-arrow-right'" class="label el-icon-arrow-right"></i>
    <div class="label-title label" v-else >{{ title }}</div>
    <el-select v-if="selectorData" v-model="value" size="small" placeholder="请选择" @change="change">
      <el-option
        v-for="(option, order) of selectorData"
        :key="'option-' + order"
        :label="option.ModelName"
        :value="option.IdStr"
      ></el-option>
    </el-select>
    <level-selector
      v-if="selectItem&&selectItem.Children"
      :selectorData="selectItem.Children"
      @selectItem="childSelectListener"
      title="el-icon-arrow-right"
    ></level-selector>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-self-import
import LevelSelector from '@/components/utils/level-selector.vue';

export default {
  name: 'level-selector',
  components: {
    LevelSelector,
  },
  props: {
    title: {
      type: String,
      default: ' ',
    },
    selectorData: {
      type: Array,
      default() {
        return [
        ];
      },
    },
  },
  data() {
    return {
      value: null,
      selectItem: null,
    };
  },
  mounted() {
    this.getInitialSelectItem();
  },
  watch: {
    // 选择的数据
    selectorData() {
      this.getInitialSelectItem();
    },
    // 获取最新的selelctor
    value(newVal) {
      this.selectItem = this.getSelectItem(newVal);
      // 保存选择到vuex
      if (this.selectItem.oType === 'xm') {
        this.$store.dispatch('projects/setSelectProject', this.selectItem.IdStr);
        if (this.selectItem.Children) {
          this.$store.dispatch('projects/setSelectProjectChild', this.selectItem.Children[0].IdStr);
        }
      } else if (this.selectItem.oType === 'pds') {
        this.$store.dispatch('projects/setSelectProjectChild', this.selectItem.IdStr);
      }
      // console.log('缓存下的项目', this.$store.getters.selectProject);
    },
    // 选择控件监听
    selectItem: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$emit('selectItem', newVal);
        }
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    change(val) {
      // const newVal = this.getSelectItem(val);
      // // 保存选择到vuex
      // if (newVal.oType === 'xm') {
      //   this.$store.dispatch('projects/setSelectProject', newVal.IdStr);
      //   if (newVal.Children) {
      //     this.$store.dispatch('projects/setSelectProjectChild', newVal.Children[0].IdStr);
      //   }
      // } else if (newVal.oType === 'pds') {
      //   this.$store.dispatch('projects/setSelectProjectChild', newVal.IdStr);
      // }
    },
    getInitialSelectItem() {
      if (!this.selectorData || this.selectorData.length === 0) {
        return;
      }
      [this.selectItem] = this.selectorData;
      if (this.selectorData[0].oType === 'xm') {
        // 从vuex取到记忆的值
        const { selectProject } = this.$store.getters;
        if (selectProject) {
          const res = this.getSelectItem(selectProject);
          if (res) {
            this.value = selectProject;
          } else {
            this.value = '';
          }
        } else {
          this.value = this.selectorData[0].IdStr;
        }
      } else if (this.selectorData[0].oType === 'pds') {
        // 从vuex取到记忆的值
        const { selectProjectChild } = this.$store.getters;
        if (selectProjectChild) {
          const res = this.getSelectItem(selectProjectChild);
          if (res) {
            this.value = selectProjectChild;
          } else {
            this.value = this.selectorData[0].IdStr;
          }
        } else {
          this.value = this.selectorData[0].IdStr;
        }
      }
      // console.log('this.selectItem', this.selectItem);
    },
    getSelectItem(value) {
      return this.selectorData.find((item) => item.IdStr === value);
    },
    childSelectListener(selectChild) {
      this.$emit('selectItem', selectChild);
    },
  },
};
</script>
<style scoped>
.label-title {
  font-size: 1.2rem;
  padding: 0 1rem;
}
.dark .label{
  color: #fff;
}
</style>
